module.exports = __webpack_public_path__ + "assets/img/ko-8aa0a612.png";